import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fd8f9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_wrap" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "全部名单", -1))
const _hoisted_4 = { class: "drawer_content" }
const _hoisted_5 = { class: "drawer_action_group" }
const _hoisted_6 = { class: "drawer_action_group" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "drawer_list" }
const _hoisted_9 = {
  style: {"height":"calc(100vh - 220px)","overflow-y":"scroll"},
  id: "scroll"
}
const _hoisted_10 = { class: "drawer_footer" }
const _hoisted_11 = { class: "btn_group" }

import { computed, reactive, ref, unref, onMounted } from 'vue';
import CDelModal from '@/components/CDelModal.vue';
import { message, Table, Input, notification } from 'ant-design-vue';
import { MemberList } from './lottery';
import http from '@/api';
import router from '@/router';
import { getCurrentInstance } from 'vue';
import { getToken } from '@/plugins/cookie';
import AddFullList from './AddFullList.vue';
import { onExport } from '@/components/CExport'; //导出
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import https from '@/api/exportList';


export default /*#__PURE__*/_defineComponent({
  __name: 'FullList',
  props: {
    dataSource: null
  },
  emits: ['click:callbackSecPage'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };

const aTable = Table;
const aInputSearch = Input.Search;

const onBlack = () => {
  emit('click:callbackSecPage');
};
const studioId = router.currentRoute.value.params.studioId;

const userList = ref<MemberList[]>([]);
const keywords = ref();
const numLength = ref(0); //内定人数
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 20, // 每页条数
  totalSize: 0, // 总页数
});
const getUserList = useDebounce(() => {
  // 名单类型 0.本地名单 1.观众参与名单 2.全部名单
  const data: any = {
    studio_id: studioId,
    keywords: keywords.value,
    type: 2,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  if (props.dataSource.drawType == 2) {
    // 活动抽奖
    data.draw_new_id = props.dataSource.drawId;
    http.lottery.getMemberListNew({ params: data }).then((res) => {
      userList.value.push(...res.data.data.data);
      numLength.value = res.data.data.fixed_number;
      pageConfig.totalSize = res.data.data.total || 0;
      pageConfig.current++;
    });
  } else {
    http.lottery.getMemberList({ params: data }).then((res) => {
      userList.value.push(...res.data.data.data);
      numLength.value = res.data.data.fixed_number;
      pageConfig.totalSize = res.data.data.total || 0;
      pageConfig.current++;
    });
  }
});
getUserList();
const onSearch = () => {
  userList.value = [];
  pageConfig.current = 1;
  getUserList();
};

//滚动加载数据
const handleScroll = () => {
  //窗口滚要做的操作写这里
  let sh = document.getElementById('scroll')?.scrollHeight || document.body.scrollHeight; // 内容可视区域的高度加上溢出（滚动）的距离
  let st = document.getElementById('scroll')?.scrollTop || document.body.scrollTop; // 滚动条距离顶部的距离
  let ch = document.getElementById('scroll')?.clientHeight || document.body.clientHeight; // 内容可视区域的高度
  // console.log('sh-%s---st-%s----ch-%s', sh, st, ch);
  if (st + ch >= sh - 100) {
    //快到底时----加载
    if (pageConfig.totalSize && userList.value.length < pageConfig.totalSize) {
      getUserList(); // 加载数据的方法
    }
  }
};
// 滚动事件
onMounted(() => {
  //监听页面滚动事件
  document.getElementById('scroll')?.addEventListener('scroll', handleScroll);
});

const columns = [
  {
    title: '观众姓名',
    dataIndex: 'realname',
    align: 'left',
  },
  {
    title: '观众信息',
    dataIndex: 'mobile',
    align: 'center',
  },
  {
    title: '分区',
    dataIndex: 'area',
    align: 'center',
  },
  {
    title: '内定',
    // dataIndex: 'mobile',
    align: 'center',
    slots: { customRender: 'nameList' },
  },
];

const selectedRowKeys = ref<string[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: string[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});

// 内定
const drawFixed = (record: any) => {
  message.destroy();
  const data: any = {
    studio_id: studioId,
    status: record.fixed === 1 ? 0 : 1,
    ids: record.id,
  };
  if (props.dataSource.drawType == 2) {
    // 活动抽奖
    data.draw_new_id = props.dataSource.drawId;
    http.lottery
      .drawFixedNew(data)
      .then((res) => {
        message.success(res.data.message);
        userList.value.forEach((e) => {
          if (e.id === record.id) {
            e.fixed = record.fixed === 1 ? 0 : 1;
          }
        });
        record.fixed ? (numLength.value += 1) : (numLength.value -= 1);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  } else {
    http.lottery
      .drawFixed(data)
      .then((res) => {
        message.success(res.data.message);
        userList.value.forEach((e) => {
          if (e.id === record.id) {
            e.fixed = record.fixed === 1 ? 0 : 1;
          }
        });
        record.fixed ? (numLength.value += 1) : (numLength.value -= 1);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
};

// 删除
const delModal = reactive<any>({
  title: '提示',
  visible: false,
  all: false,
});
const openDelModal = () => {
  delModal.visible = !delModal.visible;
};

const openDelAll = () => {
  delModal.all = !delModal.all;
};

const delUserList = () => {
  openDelModal();
  const data: any = {
    studio_id: studioId,
    ids: selectedRowKeys.value.join(','),
  };
  if (props.dataSource.drawType == 2) {
    // 活动抽奖
    data.draw_new_id = props.dataSource.drawId;
    http.lottery
      .delMemberListNew(data)
      .then((res) => {
        message.success(res.data.message);
        onSearch();
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  } else {
    http.lottery
      .delMemberList(data)
      .then((res) => {
        message.success(res.data.message);
        onSearch();
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
};

// 一键删除
const delAllList = () => {
  const data = {
    studio_id: studioId,
    type: props.dataSource.drawType === 2 ? 2 : 1,
    kind: 1, //1全部名单 2观众名单 3本地名单
    draw_new_id: props.dataSource.drawType === 2 ? props.dataSource.drawId : '',
  };
  http.lottery
    .delAllList(data)
    .then((res) => {
      message.success(res.data.message);
      openDelAll();
      onSearch();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 抽奖 名单管理 导出
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const drawExport = useDebounce((type: number, listType: number) => {
  if (props.dataSource.drawType === 2) {
    type = 35;
    const data = {
      studio_id: studioId,
      type: type,
      is_cron_download: corn.value,
      list_type: listType,
      draw_new_id: props.dataSource.drawId,
    };
    https
      .excel_regional_distribution({ params: data })
      .then((res: any) => {
        messageTip.value = res.data.message;
        openNotificationWithIcon('success');
      })
      .catch((res: any) => {
        messageTip.value = res.data.error
        openNotificationWithIcon('error');
      });
  } else {
    type = 18;
    const data = {
      studio_id: studioId,
      type: type,
      is_cron_download: corn.value,
      list_type: listType,
    };
    https
      .excel_regional_distribution({ params: data })
      .then((res: any) => {
        messageTip.value = res.data.message;
        openNotificationWithIcon('success');
      })
      .catch((res: any) => {
        messageTip.value = res.data.error
        openNotificationWithIcon('error');
      });
  }
  // 8 群聊记录 9 私聊记录  10 邀约码  11 直播间付费记录  12 表单用户信息 16 在线观众分布  18抽奖名单
  // list_type 抽奖名单类型 0.本地名单 1.观众参与 2.全部名单
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};
const addPage = ref(false);
const addList = () => {
  addPage.value = true;
};
const callbackPage = () => {
  addPage.value = false;
  onSearch();
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_a_button, {
          type: "link",
          class: "drawer_title_back",
          onClick: onBlack
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回>>")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_button, {
              class: "drawer_action_btn",
              onClick: addList
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "drawer_action_btn",
              disabled: selectedRowKeys.value.length == 0,
              onClick: openDelModal
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_a_button, {
              class: "drawer_action_btn",
              disabled: userList.value.length == 0,
              onClick: openDelAll
            }, {
              default: _withCtx(() => [
                _createTextVNode("一键删除")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(aInputSearch), {
              value: keywords.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keywords).value = $event)),
              placeholder: "搜索观众名称",
              class: "drawer_action_btn",
              style: {"width":"200px","margin-left":"16px"},
              onSearch: onSearch
            }, null, 8, ["value"])
          ]),
          _createElementVNode("span", _hoisted_7, "已内定: " + _toDisplayString(numLength.value) + "人", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(aTable), {
              "row-selection": _unref(rowSelection),
              columns: columns,
              "data-source": userList.value,
              pagination: false,
              rowKey: "id"
            }, {
              nameList: _withCtx(({ record }) => [
                _createVNode(_component_a_button, {
                  type: "link",
                  size: "small",
                  class: _normalizeClass(["Internal_but", { collection: record.fixed === 1 }]),
                  onClick: ($event: any) => (drawFixed(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, { "icon-class": "fullList_star" })
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"])
              ]),
              _: 1
            }, 8, ["row-selection", "data-source"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn",
            onClick: onBlack
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            class: "mod_modal_btn mod_type_primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(drawExport)(18, 2)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出记录")
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        ok: delUserList,
        close: openDelModal
      }, null, 8, ["visible"]),
      _createVNode(CDelModal, {
        visible: delModal.all,
        centered: "",
        ok: delAllList,
        close: openDelAll
      }, {
        title: _withCtx(() => [
          _createTextVNode("此操作将删除列表全部信息，是否继续？")
        ]),
        _: 1
      }, 8, ["visible"])
    ], 512), [
      [_vShow, !addPage.value]
    ]),
    (addPage.value)
      ? (_openBlock(), _createBlock(AddFullList, {
          key: 0,
          "data-source": {
        drawType: props.dataSource.drawType,
        drawId: props.dataSource.drawId,
      },
          "onClick:callAddPage": callbackPage
        }, null, 8, ["data-source"]))
      : _createCommentVNode("", true)
  ]))
}
}

})